import { z } from "zod"

import { PricingNumericTypeValues } from "../constants"

export const warehouseHeaderFormSchema = z.object({
  newIncoterms: z.string().optional(),
  newIncotermsLocation: z.string().optional(),
  desiredPriceChange: z.number().nullable(),
  priceChangeMode: z.nativeEnum(PricingNumericTypeValues),
})

export type WarehouseHeaderFormValues = z.infer<typeof warehouseHeaderFormSchema>
